import React, { useState } from "react";
import Collapsible from "react-collapsible";
import { useTranslation } from "react-i18next";
import { FormElements, Icon, ModalAlert } from "../../../components";
import { uploadInvoiceHelp } from "../../../../domains/invoices/service/invoices.services";
import "./invoice-help.scss";

const InvoiceHelp = () => {
    const { t } = useTranslation();

    const [fileSelected, setFileSelected] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [showAlertSuccess, setShowAlertSuccess] = useState(false);
    const [showAlertError, setShowAlertError] = useState(false);
    const maxSizePdf = 10485760;

    const handleChanges = (e) => {
        setFileSelected(e.target.files[0]);
        setIsFilePicked(true);
    };

    const handleSubmit = () => {
        if (isFilePicked && fileSelected.type === "application/pdf" && fileSelected.size < maxSizePdf) {
            const formdata = new FormData();
            formdata.append("file", fileSelected);
            uploadInvoiceHelp(formdata)
                .then(() => {
                    setShowAlertSuccess(true);
                })
                .catch(() => {
                    setShowAlertError(true);
                });
        }
    };
    return (
        <Collapsible trigger={t("users:user-menu.invoicehelp-header")} className="Collapsible" is-closed>
            <form className="form-config" encType="multipart/form-data" method="post">
                <div className="list-config">
                    <h2 className="faq__section-title">{t("users:user-menu.invoicehelp-title")}</h2>
                    <input type="file" accept="application/pdf" name="uploaded_invoice" onChange={handleChanges} className="input-config" />
                    {fileSelected && fileSelected.size > maxSizePdf && <div className="config-error">{t("users:user-menu.error-size")}</div>}
                    {fileSelected && fileSelected.type !== "application/pdf" && <div className="config-error">{t("users:user-menu.error-type")}</div>}
                    <FormElements.Button
                        className="button step-navigation__next medium primary"
                        onClick={handleSubmit}
                        disabled={(fileSelected && fileSelected.type !== "application/pdf") || (fileSelected && fileSelected.size > maxSizePdf)}>
                        {t("users:user-menu.upload")}
                        <Icon name="ui-uploaded" />
                    </FormElements.Button>
                </div>
                <ModalAlert
                    visible={showAlertSuccess}
                    onCancel={() => {
                        setShowAlertSuccess(false);
                    }}
                    title={t("users:user-menu.success-title")}
                    iconConfig="actions-validate"
                    cancelButtonText={t("users:user-menu.close")}>
                    <p>{t("users:user-menu.success-message")}</p>
                </ModalAlert>
                <ModalAlert
                    visible={showAlertError}
                    onCancel={() => {
                        setShowAlertError(false);
                        setShowAlertSuccess(false);
                    }}
                    title={t("users:user-menu.success-title")}
                    icon="message-warning"
                    cancelButtonText={t("users:user-menu.close")}>
                    <p>{t("users:user-menu.error-cgu")}</p>
                </ModalAlert>
            </form>
        </Collapsible>
    );
};
export default InvoiceHelp;
